import React from 'react';
import { getJourneyStep } from 'Components/Helpers/journeyStep';
import { EllipsisTooltip, Text } from '@upsales/components';
import t from 'Components/Helpers/translate';

export default function JourneyColumn({ account, createNewAccountRow }) {
	const status = getJourneyStep(account.journeyStep);

	const hasGroupTreeVirtualizedList = Tools.FeatureHelper.hasSoftDeployAccess('GROUP_TREE_VIRTUALIZED_LIST');
	const Component = hasGroupTreeVirtualizedList && !createNewAccountRow ? 'div' : 'td';

	if (status) {
		return (
			<Component
				className={`DataSourceColumn journey ${
					hasGroupTreeVirtualizedList && !createNewAccountRow ? 'align-items-center journey-column' : ''
				}`}
			>
				<EllipsisTooltip title={t(status.name)}>
					<Text>{t(status.name)}</Text>
				</EllipsisTooltip>
			</Component>
		);
	}
	return <Component className="DataSourceColumn journey"></Component>;
}
